import { StyleSheet } from '@react-pdf/renderer'
import Colors from '../../../assets/Colors'

export const PrintableReturnStyles = StyleSheet.create({
  page: {
    padding: 40
  },
  headerImage: {
    width: 235,
    marginBottom: 30
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12
  },
  customerNameTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: Colors.napaBlue
  },
  text: {
    fontSize: 16,
    fontWeight: 400
  },
  boldText: {
    fontSize: 16,
    fontWeight: 700
  },
  signatureTitle: {
    fontSize: 22,
    fontWeight: 400,
    color: Colors.napaBlue
  },
  signatureImage: { width: 197.75 },
  verificationTextContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 50
  },
  verificationText: {
    fontSize: 14,
    fontWeight: 400,
    color: Colors.napaGrey
  },
  table: {
    display: 'flex',
    width: 'auto'
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderStyle: 'solid',
    borderTopWidth: 1,
    borderRightWidth: 0,
    borderColor: '#bfbfbf'
  },
  tableColHeader: {
    flex: 1,
    padding: 4,
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 400,
    color: Colors.napaGrey
  },
  tableCol: {
    flex: 1,
    padding: 4,
    textAlign: 'center'
  },
  lastColHeader: {
    borderRightWidth: 0
  },
  lastCol: {
    borderRightWidth: 0
  }
})

